import {createComposedRef} from '@jetbrains/ring-ui-built/components/global/composeRefs'
import {useMemo} from 'react'

export default function useComposeRefs() {
  return useMemo(() => createComposedRef(), [])
}
